import {useQuery} from 'react-query'
import {EditModalForm} from './EditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getCompaniesFilter} from '../core/_requests'
import { CompanyStatus } from '../core/_models'

const EditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  const {
    isLoading,
    data: operator,
    error,
    status
  } = useQuery(
    `${QUERIES.OPERATORS_LIST}-operator-${itemIdForUpdate}`,
    () => {
      return getCompaniesFilter({id: itemIdForUpdate, take: 0, skip: 1})
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return (
      <EditModalForm
        isOperatorLoading={isLoading}
        response={{
          status_id: CompanyStatus.active.id,
          created_at: new Date(),
        }}
        status={status}
      />
    )
  }

  if (!isLoading && !error && operator) {
    return (
      <EditModalForm
      isOperatorLoading={isLoading}
        response={operator?.data}
        status={status}
      />
    )
  }

  return null
}

export {EditModalFormWrapper}
